import { Paragraph as ThemeParagraph, ThemeUIStyleObject } from "theme-ui";
import React, { ReactNode } from "react";

type Props = {
  children: ReactNode;
  sx?: ThemeUIStyleObject | undefined;
  as?: React.ElementType;
};

export const Paragraph: React.FC<Props> = ({ children, sx, as }) => {
  return (
    <ThemeParagraph sx={{ ...sx, fontFamily: "paragraph" }} as={as ? as : "p"}>
      {children}
    </ThemeParagraph>
  );
};
